import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useMemo } from 'react';
import { MultiSelect, Option } from 'react-multi-select-component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { MediaProps } from 'reactstrap';
import { Button, Label, Text, useColorMode } from 'theme-ui';
import * as Yup from 'yup';
import { RootState } from '../../../../@types';
import { mediaUpload } from '../../../store/actions/media.action';
import { getAllRoles, getAllUserWithoutPagination, getUserbyId } from '../../../store/actions/user.action';
import theme from '../../../theme';
import moment from 'moment';
import { bucketUrl } from '../../../utils/global';
import { ActionUpdateById } from '../../../store/actions/CommonAction';
import { skills } from '../../../utils/constent';
import { handleDepartmentChange } from '../../../utils/userDepartmentHelper';

const genders: string[] = ['Male', 'Female', 'Other'];
const validationSchema = Yup.object().shape({
  FirstName: Yup.string().required('First Name is required'),
  LastName: Yup.string().required('Last Name is required'),
  timeZone: Yup.string().required('Time zone is required'),
  userTeam: Yup.string().required('User Team is required'),
  Email: Yup.string().email('Invalid email address').required('Email is required'),
  departments: Yup.array().of(Yup.string()).required('Department is required').min(1, 'At least one department must be selected'),

  // Gender: Yup.string().required('Gender is required'),
  Role: Yup.array().of(Yup.string()).required('Role is required').min(1, 'At least one role must be selected'),
  // CanManageTo: Yup.array().of(Yup.string()).required('CanManageTo is required').min(1, 'At least one CanManageTo must be selected'),
  // TypeOfSkills: Yup.array().of(Yup.string()).required('Skills is required').min(1, 'At least one skills must be selected'),
  PhoneNumber: Yup.string().matches(
    /^[0-9]+$/,
    "Only digits are allowed!!"
  ).min(10, 'Phone number must be at least 10 digits').max(11, 'Phone number must not exceed 11 digits'),
  officeNumber: Yup.string().matches(
    /^[0-9]+$/,
    "Only digits are allowed!!"
  ).min(10, 'Office number must be at least 10 digits').max(11, 'Office number must not exceed 11 digits'),
  joiningDate: Yup.date()
    .max(new Date(), 'Joining date cannot be in the future'),


});

export interface UserFormValues {
  _id: string;
  FirstName: string;
  LastName: string;
  PhoneNumber: string | number | null;
  officeNumber: string | number | null;
  Role: string[];
  ReportingManager?: string;
  TypeOfSkills: string[];
  Gender: string;
  CanManageTo: string[];
  Email: string;
  Password?: string;
  RePassword?: string;
  ProfileImage?: string | File | null | unknown;
  userTeam: string;
  timeZone: string;
  departments: string[];
  joiningDate: string;
  NextEvalution: string;
}

const EditUserForm: React.FC = () => {
  const navigate = useNavigate();
  const { userId } = useParams<{ userId: string }>();
  const { uploadedMedia } = useSelector((state: MediaProps) => state?.media);
  const userData = useSelector((state: RootState) => state?.user);
  const { createprojectMasterData } = useSelector((state: RootState) => state.project)
  const [colorMode] = useColorMode();
  const Users = userData?.userData?.data;
  const { usersbyId } = useSelector((state: RootState) => state.user)
  const { roles } = useSelector((state: RootState) => state.user);
  const userTeam = [
    { label: 'PEC', value: 'PEC' },
    { label: 'QDC', value: 'QDC' },
  ]
  const timeZones = [
    { label: 'PST', value: 'America/Los_Angeles' },
    { label: 'IST', value: 'Asia/Calcutta' },
  ]
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserbyId(userId));
    dispatch(getAllRoles());
    dispatch(getAllUserWithoutPagination())
  }, [dispatch, userId]);
  const handleProfileImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = (event.target.files as FileList)[0];
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'user');
      formData.append('uploadType', 'File');
      dispatch(mediaUpload(formData));
    } else {
      console.warn('Profile Image not found!');
    }
  };
  const initialValues: UserFormValues = {
    _id: usersbyId?._id || '',
    FirstName: usersbyId?.FirstName || '',
    LastName: usersbyId?.LastName || '',
    PhoneNumber: usersbyId?.PhoneNumber || '',
    officeNumber: usersbyId?.officeNumber || '',
    Role: usersbyId?.Role?.map((r: { _id: string }) => r._id) || [],
    ReportingManager: usersbyId?.ReportingManager || '',
    TypeOfSkills: usersbyId?.TypeOfSkills || [],
    Gender: usersbyId?.Gender || '',
    CanManageTo: usersbyId?.CanManageTo?.map((item: { _id: string }) => item?._id) || [],
    Email: usersbyId?.Email || '',
    Password: usersbyId?.Password || '',
    RePassword: usersbyId?.Password || '',
    ProfileImage: usersbyId?.ProfileImage || uploadedMedia,
    userTeam: usersbyId.userTeam || '',
    timeZone: usersbyId.timeZone || '',
    departments: (usersbyId?.departments?.map((dept: { _id?: string } | string) => typeof dept === 'object' && dept !== null ? dept._id : dept) || []).filter((id): id is string => Boolean(id)),
    joiningDate: usersbyId?.joiningDate ? moment(usersbyId?.joiningDate).format("YYYY-MM-DD") : '',
    NextEvalution: usersbyId?.NextEvalution ? moment(usersbyId?.NextEvalution).format("YYYY-MM-DD") : '',
  };

  const handleSubmit = (values: UserFormValues) => {
    const payload: Record<string, unknown> = { ...values };
    if (uploadedMedia) {
      payload.ProfileImage = uploadedMedia;
    }
    if (!payload?.ReportingManager) {
      delete payload?.ReportingManager;
    }
    if (payload.PhoneNumber && Number(payload.PhoneNumber) !== 0) {
      payload.PhoneNumber = Number(payload.PhoneNumber);
    } else {
      payload.PhoneNumber = null;
    }

    if (payload.officeNumber && Number(payload.officeNumber) !== 0) {
      payload.officeNumber = Number(payload.officeNumber);
    } else {
      payload.officeNumber = null;
    }
    const { Password, RePassword, ...payloadWithoutId } = payload;

    dispatch(ActionUpdateById({ Query: `users/editUser/${userId}`, obj: payloadWithoutId }, (res: unknown) => {
      navigate(-1)
    }));
  };

  const canManageToOptions: Option[] = Users?.map((user: { FirstName: string; _id: string }) => ({
    label: user?.FirstName,
    value: user?._id,
  }));
  const roleOptions: Option[] = roles?.data?.map((roles: { RoleName: string; _id: string }) => ({
    label: roles?.RoleName,
    value: roles?._id,
  }));
  const departments: Option[] = useMemo(() => createprojectMasterData?.allDepartments?.data?.map((departments: { name: string; _id: string }) => ({
    label: departments?.name,
    value: departments?._id,
  })) || [], [createprojectMasterData?.allDepartments?.data]);
  return (
    <div className="main-content p-5" >
      <h1 style={{ color: colorMode === "light" ? "black" : "white" }}>Edit User
        {/* {usersbyId?.ProfileImage && <Avatar width={40} height={40} variant="profile" src={`${bucketUrl}${usersbyId?.ProfileImage}`} style={{ backgroundColor: "white" }} />} */}
      </h1>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize={true}>
        {({ errors, touched, setFieldValue, values }) => (
          <Form>
            <div className="row">
              <div className="col-md-4 mt-4">
                <Label htmlFor="FirstName" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.FirstName && touched.FirstName ? 'is-invalid' : ''}`}>First Name<span className="text-danger">*</span></Label>
                <Field type="text" id="FirstName" name="FirstName" className="form-control" placeholder="First Name" />
                <ErrorMessage name="FirstName" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="LastName" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.LastName && touched.LastName ? 'is-invalid' : ''}`}>Last Name<span className="text-danger">*</span></label>
                <Field type="text" id="LastName" name="LastName" className="form-control" placeholder="Last Name" />
                <ErrorMessage name="LastName" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="Email" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.Email && touched.Email ? 'is-invalid' : ''}`}>Email ID<span className="text-danger">*</span></label>
                <Field type="text" id="Email" name="Email" className="form-control" placeholder="Email ID" />
                <ErrorMessage name="Email" component="div" className="text-danger" />
              </div>
              {/* <div className="col-md-4 mt-4">
                <label htmlFor="Project" className="form-label">Project<span className="text-danger">*</span></label>
                <Field type="text" id="Project" name="Project" className="form-control" placeholder="Project" />
                <ErrorMessage name="Project" component="div" className="text-danger" />
              </div> */}
              <div className="col-md-4 mt-4">
                <label htmlFor="Gender" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Gender<span className="text-danger">*</span></label>
                <Field as="select" id="Gender" name="Gender" className={`form-control `}
                  // onChange={(e) => setFieldValue('Gender', e.target.value)}
                  value={values.Gender} >
                  <option value="" label="Select Gender" />
                  {genders.map((gender) => (<option key={gender} value={gender} label={gender} />))}
                </Field>
                {/* <ErrorMessage name="Gender" component="div" className="text-danger" /> */}
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="Role" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Role Name<span className="text-danger">*</span></label>
                {roleOptions.length > 0 && <MultiSelect
                  options={roleOptions || []}
                  value={(values?.Role || []).map((value: string) => roleOptions?.find((option) => option?.value === value)).filter((option: Option | undefined): option is Option => Boolean(option))}
                  onChange={(selected: Option[]) => setFieldValue('Role', selected?.map((option) => option?.value))}
                  labelledBy="Select"
                />}
                {errors?.Role && touched?.Role ? (
                  <Text variant="Inter15Regular30lh" className="text-danger" sx={{ my: '5px', minHeight: '11px', lineHeight: '10px' }}>
                    {'At least one role must be selected'}
                  </Text>
                ) : (
                  null
                )}
              </div>
              <div className="col-md-4 mt-3">
                <label htmlFor="PhoneNumber" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Phone Number</label>
                <Field type="text" id="PhoneNumber" name="PhoneNumber" className="form-control" placeholder="Phone Number" />
                <ErrorMessage name="PhoneNumber" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-3">
                <label htmlFor="officeNumber" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Office Number</label>
                <Field type="text" id="officeNumber" name="officeNumber" className="form-control" placeholder="Office Number" />
                <ErrorMessage name="officeNumber" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="ReportingManager" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Reporting Manager</label>
                <Field as="select" id="ReportingManager" name="ReportingManager" className="form-control" >
                  <option value="" label="Select Reporting Manager" />
                  {Users?.map((user: { FirstName: string; _id: string }) => (
                    <option
                      key={user?._id}
                      value={user?._id}
                      label={user?.FirstName}
                      selected={user?._id === values?.ReportingManager} />))}
                </Field>
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="CanManageTo" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Can Manage to</label>
                {canManageToOptions?.length > 0 && <MultiSelect
                  options={canManageToOptions}
                  value={(values?.CanManageTo || [])
                    .map((value: string) => canManageToOptions?.find((option) => option?.value === value))
                    .filter((selectedOption: Option | undefined): selectedOption is Option => Boolean(selectedOption))}
                  onChange={(selected: Option[]) => {
                    const selectedValues = selected?.map((option) => option?.value);
                    setFieldValue('CanManageTo', selectedValues || []);
                  }}
                  labelledBy="Select" />}

              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="TypeOfSkills" style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Types of Skills</label>
                {skills.length > 0 && <MultiSelect
                  options={skills || []}
                  value={(values?.TypeOfSkills || []).map((value: string) => skills.find((option) => option.value === value)).filter((option: Option | undefined): option is Option => Boolean(option))}
                  onChange={(selected: Option[]) => setFieldValue('TypeOfSkills', selected?.map(option => option?.value))}
                  labelledBy="Select" />}

              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="userTeam" className="form-label" style={{ color: colorMode === "light" ? "black" : "white" }}>User Team<span className="text-danger">*</span></label>
                <Field
                  as="select"
                  id="userTeam"
                  name="userTeam"
                  className={`form-control`}
                >
                  <option value="" label="Select User Team" />
                  {userTeam?.map((user: { label: string; value: string }, index: number) => (
                    <option key={index} value={user.value} label={user.label} />
                  ))}
                </Field>
                <ErrorMessage name="userTeam" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="timeZone" className="form-label" style={{ color: colorMode === "light" ? "black" : "white" }}>Time Zone<span className="text-danger">*</span></label>
                <Field
                  as="select"
                  id="timeZone"
                  name="timeZone"
                  className={`form-control`}
                >
                  <option value="" label="Select Time Zone" />
                  {timeZones?.map((user: { label: string; value: string }, index: number) => (
                    <option key={index} value={user?.value} label={user?.label} />
                  ))}
                </Field>
                <ErrorMessage name="timeZone" component="div" className="text-danger" />
              </div>
              <div className='col-md-4 mt-4'>
                <label htmlFor='joiningDate' className="form-label" style={{ color: colorMode === "light" ? "black" : "white" }}>Joining Date</label>
                <Field type="date" id="joiningDate" name="joiningDate" className="form-control" placeholder="Enter Date" />
                <ErrorMessage name="joiningDate" component="div" className="text-danger" />
              </div>
              <div className="col-md-4 mt-4">
                <label htmlFor="departments" className="form-label" style={{ color: colorMode === "light" ? "black" : "white" }}>Department<span className="text-danger">*</span></label>
                {departments?.length > 0 && (
                  <div title={(values?.departments || []).map((value: string) => departments?.find((option) => option?.value === value)?.label).filter((label): label is string => Boolean(label)).join(', ')}>
                    <MultiSelect
                      options={departments}
                      value={(values?.departments || []).map((value: string) => departments?.find((option) => option?.value === value)).filter((option: Option | undefined): option is Option => Boolean(option))}
                      onChange={(selected: Option[]) => {
                        const updatedDepartments = handleDepartmentChange(selected, values?.departments || [], departments);
                        setFieldValue('departments', updatedDepartments);
                      }}
                      labelledBy="Select"
                    />
                  </div>
                )}
                {touched.departments && typeof errors.departments === 'string' && (
                  <Text
                    variant="Inter15Regular30lh"
                    className="text-danger"
                    sx={{ my: '5px', minHeight: '11px', lineHeight: '10px' }}
                  >
                    {errors.departments}
                  </Text>
                )}

              </div>
              <div className='col-md-12 mt-4'><h2 style={{ color: colorMode === "light" ? "black" : "white" }}>System Field</h2></div>
              <div className='col-md-4 mt-4'>
                <label htmlFor='ProfileImage' style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Profile Image</label>
                <input
                  type="file"
                  id="ProfileImage"
                  name="ProfileImage"
                  onChange={handleProfileImageChange}
                  className={`form-control ${errors.ProfileImage && touched.ProfileImage ? 'is-invalid' : ''}`}
                />
                {usersbyId?.ProfileImage && <a target='_blank' href={bucketUrl + usersbyId?.ProfileImage}>{usersbyId?.ProfileImage.slice(usersbyId?.ProfileImage.length - 21, usersbyId?.ProfileImage.length)}</a>}
              </div>
              <div className='col-md-4 mt-4'>
                <label htmlFor='Evaluation' style={{ color: colorMode === "light" ? "black" : "white" }} className="form-label">Next Evaluation</label>
                <Field type="date" id="Evaluation" name="Evaluation" className="form-control" placeholder="Enter Date" />
              </div>
            </div>
            <div className='row mt-5'>
              <div className='col-md-4'></div>
              <div className='col-md-4'><Button type="reset" sx={{ border: `1px solid ${theme.colors?.primary || 'defaultBorderColor'}`, background: 'white', color: theme.colors?.muted, borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} onClick={() => navigate(-1)}> Cancel </Button></div>
              <div className='col-md-4'><Button sx={{ borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} type='submit'>Submit</Button></div>
            </div>
          </Form>)}
      </Formik>
    </div >
  );
};

export default EditUserForm;
